import clsx from "clsx";
import { Button, Theme, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useFormikContext } from "formik";

import { CUSTOM_PANELS } from "helpers/apis";
import useCatalogDetail from "hooks/useCatalogDetail";
import useDraftCustomPanels from "pages/Dashboard/DraftCustomPanels/useDraftCustomPanel";
import { ICustomPanelForm } from "types/form";
import { ICustomPanel } from "types/panel";

const useStyles = makeStyles((theme: Theme) => ({
  button: { textTransform: "none" },
  flexOrder: {
    [theme.breakpoints.only("sm")]: { order: 1 },
    [theme.breakpoints.down('sm')]: {
      order: 3,
      width: "100%",
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  },
}));

export const SaveDraftButton = () => {
  const classes = useStyles();

  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  const {
    customPanelAction,
    draftSaved,
    isDraftCustomPanel,
    setDraftAlertStatus,
    setDraftSaved,
  } = useCatalogDetail();
  const { setDraftCustomPanels } = useDraftCustomPanels();
  const { isValid, setFieldError, setSubmitting, values } =
    useFormikContext<ICustomPanelForm>();

  const onSave = () => {
    customPanelAction({
      values: { ...values, status: "draft" },
      actions: { setFieldError, setSubmitting },
      callback: ({ data }: { data: ICustomPanel }) => {
        setDraftSaved(data);
        setDraftAlertStatus("success");
        if (isDraftCustomPanel) {
          setDraftCustomPanels((draftCustomPanels) => [
            ...draftCustomPanels.map((item) => {
              if (item.id === data.id) {
                return {
                  ...data,
                  workflow: item.workflow,
                  diseaseType: item.diseaseType,
                };
              }
              return item;
            }),
          ]);
        }
      },
      confirmed: undefined,
      errorCallback: () => {
        setDraftAlertStatus("error");
      },
      config: {
        url: draftSaved ? `${CUSTOM_PANELS}${draftSaved.id}` : CUSTOM_PANELS,
        method: draftSaved ? "PUT" : "POST",
      },
    });
  };

  return (
    <Button
      fullWidth={mdUp}
      variant="outlined"
      size={mdUp ? "medium" : "small"}
      className={clsx(classes.button, classes.flexOrder)}
      disabled={!isValid || !values.panelName}
      onClick={onSave}
    >
      Save
    </Button>
  );
};
